module.exports = __webpack_public_path__ + "assets/img/4e8423dbf14fd53ae440b81309466e58.png";